import { BiBell } from 'react-icons/bi';
import { IoKeyOutline } from 'react-icons/io5';
import styles from './Settings.module.css';
import { Switch } from 'antd';
import language from '../../../assets/language.png';
import "./overide.css";
import { useNavigate } from 'react-router';
import { t } from 'i18next';
import { useState } from 'react';
import NotificationMiddleware from '../../../store/Middlewares/NotificationMiddleware';
import { useDispatch, useSelector } from 'react-redux';
const Settings = ( ) =>{
    const user = useSelector(state => state.AuthReducer.user);
    const dispatch= useDispatch(); 
    const [NotificationOn, setNotificationOn] = useState(
        user?.is_receive_notification == 1 ? true : false,
      );
      console.log('userActive', user?.is_receive_notification)
    const navigate = useNavigate();
    const onChange = () => {
        setNotificationOn(!NotificationOn);
        dispatch(NotificationMiddleware.toggleNotifications());
        console.log('///////////', user?.is_receive_notification );

      };
    return(
        <div className={styles.mainDiv}>
            <div className={styles.heading}>
                <h1>{t("Settings")}</h1>
            </div>
            <div className={styles.content}>
                <div className={styles.subContent}>
                    <div className={styles.head}>
                        <p>{t("Notifications")}</p>
                        <BiBell className={styles.bellIcon}/>
                    </div>
                    <div className={styles.switch}>
                    <Switch className='switch'  onClick={onChange}  checked={NotificationOn} />
                    </div>
                </div>
                <div className={styles.subContent} onClick={()=>navigate('/Settings/ChangePassword')} >
                    <div className={styles.head}>
                        <p>{t("Change Password")}</p>
                        <IoKeyOutline className={styles.bellIcon}/>
                    </div>
                </div>
                <div className={styles.subContent} onClick={()=>navigate('/Settings/Language')}>
                    <div className={styles.head}>
                        <p>{t("Language")}</p>
                        <img src={language}/>
                    </div>
                </div>
            </div>
        </div>
    )
};
export default Settings;